import * as Sentry from '@sentry/react'
import { SentryENV } from '@/constants/appConfig'

export const isSentryEnabled = (): boolean => {
  return (
    SentryENV === 'production' ||
    SentryENV === 'pre-prod' ||
    import.meta.env.VITE_SENTRY_ENABLED === 'true'
  )
}

export const setSentryUser = (userId: number): void => {
  Sentry.getGlobalScope().setUser({ id: userId })
}

export const clearSentryUser = (): void => {
  Sentry.getGlobalScope().setUser({ id: undefined })
}

export const getSentryUser = () => {
  return Sentry.getGlobalScope().getUser()
}

export const logApiErrorToSentry = (error: unknown, url: string, customMessage?: string): void => {
  const typedError = error as {
    response?: { data?: { message?: string }; statusCode?: number; status?: number }
    message?: string
  }
  const isCustomResponse = Boolean(typedError?.response)
  const response = isCustomResponse ? typedError.response : typedError

  const baseMessage = isCustomResponse
    ? (typedError.response?.data?.message ?? `API failure:- ${customMessage}`)
    : (typedError?.message ?? String(error))

  const fullMessage = customMessage ? `${baseMessage}:- ${customMessage}` : baseMessage

  Sentry.captureException(error, {
    tags: {
      error_type: 'api',
      http_method: 'POST',
      url,
      error_message: String(fullMessage),
      status_code: String(
        (response as { statusCode?: number; status?: number })?.statusCode ??
          (response as { statusCode?: number; status?: number })?.status ??
          'unknown'
      ),
    },
    extra: {
      response_data: response,
      userAgent: navigator.userAgent,
      request_data: url,
    },
  })
}
